export default {
  data() {
    return {
      grammarErrors: [
        /(^|\s)(e|o|a)(\s|$)/i, // Incorrect article usage
        /\b(quero|preciso|vou)\sde ir\b/i, // Unnecessary "de" before verb
        /(\btemos\sque\b|\btens\sque\b)/i, // Incorrect verb form
        /\b(a\smeu)\sver\b/i, // Incorrect possessive pronoun
        /\b(vou|quero|preciso)\spara ir\b/i, // Unnecessary "para" before verb
        /(\bcom\sque\b|\bcom\sdo\b)/i, // Incorrect preposition usage
        /\b(porque|por que)\b/i, // Incorrect use of "porque" or "por que"
        /\b(tinha|tinham)\sque fazer\b/i, // Incorrect verb form
        /(\bem\sque\b|\bestá\sque\b)/i, // Incorrect adverb usage
        /\b(vou|vamos|irei|iremos)\sde ir\b/i, // Redundant "de" before verb
        /\b(eu\svejo|eu\sou)\sque\b/i, // Incorrect use of "eu vejo" or "eu sou" before "que"
        /\b(esta|esse|esse|aquel)\sque\b/i, // Incorrect use of demonstrative pronouns
        /\bem\s(dia|manhã|tarde|noite)\b/i, // Incorrect use of preposition "em" before time expressions
        /(\bno\sque\b|\bna\sque\b)/i, // Incorrect use of preposition before "que"
        /\bem\s(todos|todas)\s(o|a|os|as)\b/i, // Incorrect use of preposition "em" before plural demonstrative pronouns
        /\bde\s(a|o)\squal\b/i, // Incorrect use of preposition "de" before "qual"
        /\bmais\s(barato|caro)\sque\b/i, // Incorrect use of comparative adjective
        /\b(na|em)\so\sque\b/i, // Incorrect use of preposition before "o que"
        /\b(ao\sque|aos\sque)\b/i, // Incorrect use of preposition "ao" or "aos" before "que"
        /\bque\s(não|nao)\b/i, // Incorrect use of "que não" or "que nao"
        /\b(da|do)\s(a|o)\squal\b/i, // Incorrect use of preposition "da" or "do" before "qual"
        /\bnão\s(deve|precisa|consegue)\sde\s(\w+)/i, // Incorrect use of "não" before verb
        /\b(você|tu|vocês|voces)\sé\b/i, // Incorrect conjugation of "ser" verb
        /\b(você|tu|vocês|voces)\sera\b/i, // Incorrect conjugation of "será" verb
        /\bser\s(de)\s(\w+)/i, // Incorrect use of "ser de" construction
        /\b(você|tu|vocês|voces)\svai\sfazer\s(isso|isto|isso)\b/i, // Incorrect use of "vai fazer" construction
        /\ba\s(mim|ti|si|ele|ela|nós|vós|eles|elas)\sque\b/i, // Incorrect use of personal pronouns before "que"
        /\b(neste|nesse|nessa|naquele|naquela|naqueles|naquelas)\sq(e|ue)\b/i, // Incorrect use of "q" instead of "qu" in conjunction with prepositions
        /\b(dentro|fora|em|entre|sobre|para|de|sem|com|até|desde|durante|por|perante|segundo|atraso|adianto|conforme|contra|mediante|consoante|exceto|salvo|excipiente|como|além|a|à|ao|às|aos)\s(o|a|os|as)\b/i, // Incorrect use of prepositions before definite articles
        /\bem\s(\d+)\s(horas|minutos|segundos|dias|semanas|meses|anos)\b/i, // Incorrect use of preposition "em" before time expressions
        /\b(\d+)\s(de\s)?(horas|minutos|segundos|dias|semanas|meses|anos)\b/i, // Incorrect use of time expressions without preposition
        /\b((\d+)\s)?(hora|minuto|segundo|dia|semana|mês|ano)s\b/i, // Incorrect use of plural/singular forms in time expressions
        /\bnão\s(\w+)\s(\w+)\s(\w+)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(\w+)\s(\w+)\s(não)\b/i, // Incorrect negation placement
        /\b(\w+)\sque\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(\w+)\sque\s(\w+)\s(não)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(\w+)\s(\w+)\b/i, // Incorrect negation placement
        /\b(\w+)\s(\w+)\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(\w+)\s(\w+)\s(\w+)\s(não)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(pode|consegue)\s(\w+)\b/i, // Incorrect negation placement
        /\b(pode|consegue)\s(\w+)\snão\s(\w+)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(pode|consegue)\s(\w+)\s(nada|nunca|mais)\b/i, // Incorrect negation placement
        /\b(nada|nunca|mais)\s(\w+)\snão\s(\w+)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(pode|consegue)\s(\w+)\s(de modo algum|de jeito nenhum|de forma alguma)\b/i, // Incorrect negation placement
        /\b(de modo algum|de jeito nenhum|de forma alguma)\s(\w+)\snão\s(\w+)\b/i, // Incorrect negation placement
        /\b(não)\s(\w+)\s(pode|consegue)\s(\w+)\s(de modo algum|de jeito nenhum|de forma alguma)\b/i, // Incorrect negation placement
        /\b(não)\s(\w+)\s(pode|consegue)\s(\w+)\s(nada|nunca|mais)\b/i, // Incorrect negation placement
        /\b(nada|nunca|mais)\s(\w+)\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(de modo algum|de jeito nenhum|de forma alguma)\s(\w+)\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(pode|consegue)\s(\w+)\s(nada|nunca|mais)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(pode|consegue)\s(\w+)\s(de jeito nenhum|de forma alguma)\b/i, // Incorrect negation placement
        /\b(de jeito nenhum|de forma alguma)\s(\w+)\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(não)\s(\w+)\s(pode|consegue)\s(\w+)\s(de jeito nenhum|de forma alguma)\b/i, // Incorrect negation placement
        /\b(não)\s(\w+)\s(pode|consegue)\s(\w+)\s(de acordo com|segundo|consoante)\b/i, // Incorrect negation placement
        /\b(de acordo com|segundo|consoante)\s(\w+)\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(pode|consegue)\s(\w+)\s(de acordo com|segundo|consoante)\b/i, // Incorrect negation placement
        /\b(não)\s(\w+)\s(pode|consegue)\s(\w+)\s(de acordo com|segundo|consoante)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(pode|consegue)\s(\w+)\s(em hipótese alguma)\b/i, // Incorrect negation placement
        /\b(em hipótese alguma)\s(\w+)\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(não)\s(\w+)\s(pode|consegue)\s(\w+)\s(em hipótese alguma)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(pode|consegue)\s(\w+)\s(sob nenhuma circunstância)\b/i, // Incorrect negation placement
        /\b(sob nenhuma circunstância)\s(\w+)\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(não)\s(\w+)\s(pode|consegue)\s(\w+)\s(sob nenhuma circunstância)\b/i, // Incorrect negation placement
        /\b(\w+)\s(não)\s(pode|consegue)\s(\w+)\s(a qualquer custo)\b/i, // Incorrect negation placement
        /\b(a qualquer custo)\s(\w+)\s(não)\s(\w+)\b/i, // Incorrect negation placement
        /\b(não)\s(\w+)\s(pode|consegue)\s(\w+)\s(a qualquer custo)\b/i // Incorrect negation placement
      ]
    };
  },
  methods: {
    hasGrammarErrors(text) {
      for (const pattern of this.grammarErrors) {
        if (pattern.test(text)) {
          return true; // Grammar error found
        }
      }

      return false; // No grammar errors detected
    }
  }
};
